import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import {
    useIsDialogOpened,
    useNestedDialogFunction,
} from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import React from 'react';
import { Controlled_AutocompleteReferenceTextField } from './Controlled_AutocompleteReferenceTextField';
import {
    ProcessAreaEditDialog,
} from '../../../page-components/project/reusable-elements/process-area/ProcessAreaEditDialog';
import {
    ProcessAreaCreationDialog,
} from '../../../page-components/project/reusable-elements/process-area/ProcessAreaCreationDialog';
import { useMyNavigate } from '../../../router/createdRouter';
import { useProcessAreaActions } from '../../../../resource/resources/artifacts/process_area/processAreaResource';
import { useSystemInformationActions } from '../../../../resource/services/systemInformationService';

export const Controlled_ProcessAreaTextField= ({ objectId, projectVersionId, projectId, onChange, readOnly, noLabel, propertyValidationInformation }: {
    objectId: string | undefined | null;
    projectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    onChange?: (id: string | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation: PropertyValidationInformation;
}) => {
    const navigate = useMyNavigate();

    const nestedDialog = useNestedDialogFunction();
    const isNestedDialogOpen = useIsDialogOpened();

    const processAreaActions = useProcessAreaActions();
    const systemInformationActions = useSystemInformationActions();
    const processAreasQuery = processAreaActions.useGetAllResources(projectVersionId);
    const propertyDetails = systemInformationActions.useGetPropertyDetails(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType,
    );
    const propertyValidation = systemInformationActions.useGetPropertyValidationWithId(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType,
        propertyValidationInformation.resourceId ?? '',
    );

    const onGoToClick = (resourceId: string | undefined, openInNewTab: boolean) => {
        const url = `/project/${projectId}/active-version/${projectVersionId}/process-area/${resourceId}`;
        if (isNestedDialogOpen) {
            window.open(url, `processArea_${resourceId}`);
        } else {
            navigate({
                route: '/project/:id/active-version/:versionId/process-area/:processAreaId',
                routeParams: {
                    id: projectId ?? '',
                    versionId: projectVersionId ?? '',
                    processAreaId: resourceId ?? '',
                },
                searchParams: {},
            });
        }
    };

    const onEdit = () => {
        nestedDialog.showNestedDialog(
            <ProcessAreaEditDialog
                onClose={nestedDialog.closeNestedDialog}
                objectId={objectId}
                versionedInId={projectVersionId ?? ''}
            />,
        );
    };

    const onAdd = () => {
        nestedDialog.showNestedDialog(
            <ProcessAreaCreationDialog
                onClose={nestedDialog.closeNestedDialog}
                parentId={projectVersionId ?? ''}
                onCreated={(_, newObjectId) => {
                    if (onChange) {
                        onChange(newObjectId);
                    }
                }}
            />,
        );
    };

    return (
        <Controlled_AutocompleteReferenceTextField
            idValue={objectId}
            readOnly={readOnly}
            onGoToClick={onGoToClick}
            onChange={onChange}
            propertyValidation={propertyValidation}
            propertyDetails={noLabel ? undefined : propertyDetails}
            query={processAreasQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
            onAdd={onAdd}
            onEdit={onEdit}
        />
    );
};